import { render, staticRenderFns } from "./EmptyListPlaceholder.vue?vue&type=template&id=7be5d6f9&scoped=true"
import script from "./EmptyListPlaceholder.vue?vue&type=script&lang=js"
export * from "./EmptyListPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./EmptyListPlaceholder.vue?vue&type=style&index=0&id=7be5d6f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be5d6f9",
  null
  
)

export default component.exports